import React from 'react';
import { CrossSellWrapper } from 'core/context/CrossSellWrapper/CrossSellWrapper';
import { RootState } from 'store/store.types';
import { useSelector } from 'react-redux';

export type MapActivitiesStateToShouldRenderCrossSellWrapper = (state: RootState) => {
    shouldRender: boolean;
};

const defaultSelector = () => ({ shouldRender: false });

const withCrossSellWrapper =
    (mapActivitiesStateToShouldRender: MapActivitiesStateToShouldRenderCrossSellWrapper = defaultSelector) =>
    <T extends React.JSX.IntrinsicAttributes>(WrappedComponent: React.ComponentType<T>): React.FC<T> => {
        const Component: React.FC<T> = (props) => {
            const { shouldRender } = useSelector(mapActivitiesStateToShouldRender);
            if (!shouldRender) {
                return null;
            }
            return (
                <CrossSellWrapper>
                    <WrappedComponent {...props} />
                </CrossSellWrapper>
            );
        };
        Component.displayName = `withCrossSellWrapper(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
        return Component;
    };

export { withCrossSellWrapper };
